export default __webpack_public_path__ + "static/media/lodgify_step8.0659eaaa.jpg";